// ثبت Widgetهای سربرگ مشترک مراجعه‌کننده (COMP-PATIENT-HEADER — AP-PAT-02). هر ماژول برای کلید بخش خود
// (`IPatientSummaryContributor` سمت سرور) یک کامپوننت اینجا اضافه می‌کند؛ بخشی که Widget ندارد با GenericSummaryWidget
// نمایش داده می‌شود. راهنما: docs/08-engineering/patient-header-widgets.md.
import type { PatientSummarySection } from '@phoenix/api-client';
import type { ComponentType } from 'react';
import { BalanceWidget } from '../billing/BalanceWidget';
import { ClinicalAlertsWidget } from '../clinical/ClinicalAlertsWidget';
import { NextAppointmentWidget } from '../scheduling/NextAppointmentWidget';

export interface PatientHeaderWidgetProps {
  section: PatientSummarySection;
  patientId: string;
}

/** کلید بخش ← Widget: SCH نوبت بعد، BIL مانده (AP-BIL-01؛ کیف پول با AP-BIL-02) و CLN هشدارها (AP-CLN-01). */
export const PATIENT_HEADER_WIDGETS: Readonly<Record<string, ComponentType<PatientHeaderWidgetProps>>> = {
  'sch.next_appointment': NextAppointmentWidget,
  'bil.balance': BalanceWidget,
  // AP-CLN-01: هشدار بالینی (AC-CLN-060.2).
  'cln.alerts': ClinicalAlertsWidget,
};
